import { Outlet } from 'react-router';
import FundProvider from '@/contexts/Fund/FundProvider';
import useFundContext from '@/contexts/Fund/useFundContext';

const UserPage = () => {
  return (
    <>
      {/*
        HAT-1238 Fold 280: this is a flex *item* of .frame-section AND a flex
        *container* for sidebar + .content-container. Default min-width:auto lets
        a nowrap fund name (or leftover 160px tiles) inflate the whole /new shell
        to ~327px — tabs, summary and balance then clip together. min-w-0 breaks
        that min-content chain.
      */}
      <div className="flex items-start w-full min-w-0 max-w-full">
        <FundProvider>
          <FundOutlet />
        </FundProvider>
      </div>
    </>
  );
};

const FundOutlet = () => {
  const { currentFund } = useFundContext();
  return currentFund?.id ? <Outlet /> : null;
};

export default UserPage;
